import { createPortal } from 'react-dom';

const PortalWrapper = ({
  children,
  container = document.querySelector('#__next main'),
}: {
  children: React.ReactNode;
  container?: Element | DocumentFragment;
}) => {
  return createPortal(children, container);
};

export default PortalWrapper;
